export const tooltipDataList = {
  firstSlide: [
    {
      id: 1,
      iconPrimaryColor: '#33CC66',
      iconSecondaryColor: '#5b32ff',
      title: 'Acceptable 1',
      text_content: 'The grid with a relative high score in the City/District based on weighted spatial parameters like POI, Demographic, SES, and People Density. These grids tend to be the most acceptable area to expand',
    },
    {
      id: 2,
      iconPrimaryColor: '#FFEB99',
      iconSecondaryColor: '#16A793',
      title: 'Acceptable 2',
      text_content: 'The grid with the second highest score in the City/District based on weighted spatial parameters such as POI, Demographic, SES, and People Density which have been set up previously. These grids tend to be the second alternative acceptable area to expand',
    },
    {
      id: 3,
      iconPrimaryColor: '#FF9966',
      iconSecondaryColor: '#FF8A00',
      title: 'Acceptable 3',
      text_content: 'The grid with the less score in the City/District based on weighted spatial parameters including POI, Demographics, SES, and People Density. These grids tend to be the third alternative acceptable area to expand',
    },
  ],
  secondSlide: [
    {
      id: 4,
      iconPrimaryColor: '#FF0066',
      iconSecondaryColor: '#FF9DBD',
      title: 'Acceptable 4',
      text_content: 'The grid has the second lowest score in the City/District according to weighted spatial parameters such as POI, Demographics, SES, and People Density. Grids like these are not really recommended areas to expand',
    },
    {
      id: 5,
      iconPrimaryColor: '#657991',
      iconSecondaryColor: '#D9DDE1',
      title: 'Unacceptable',
      text_content: 'Grid that has a relatively lowest scoring in its City/District based on weighted spatial parameters such as POIs, Demographics, SES, and People Density. These grids are not recommended for expansion',
    },
  ],
};
